import ErrorPage from "@pages/ErrorPage"
import LoadingPage from "@pages/LoadingPage"
import { Suspense, useEffect } from "react"
import {
  Await,
  Navigate,
  useLoaderData,
  useSearchParams,
} from "react-router-dom"

export default function PaymentCompletionPage() {
  const data = useLoaderData() as { completed: Promise<boolean> }

  const [searchParams] = useSearchParams()

  const currency = searchParams.get("currency")!
  const fullPrice = searchParams.get("full_price")!
  const paymentIntentClientSecret = searchParams.get(
    "payment_intent_client_secret",
  )!
  const plan = searchParams.get("plan")!
  const stripeFirstPriceId = searchParams.get("stripe_first_price_id")!
  const stripeNextPriceId = searchParams.get("stripe_next_price_id") ?? ""
  const subscriptionId = searchParams.get("subscription_id") ?? ""
  const isOneTime = plan === "one-time"

  useEffect(() => {
    const timeout = setTimeout(() => {
      // NOTE: Just wait one second to let the Facebook Pixel do its job
    }, 1000)

    return () => {
      clearTimeout(timeout)
    }
  }, [])

  return (
    <Suspense fallback={<LoadingPage />}>
      <Await errorElement={<ErrorPage />} resolve={data.completed}>
        {(completed) =>
          completed ? (
            isOneTime ? (
              <Navigate to="/account/subscription" replace />
            ) : (
              <Navigate to="/checkout/gift" replace />
            )
          ) : (
            <Navigate
              to={`/checkout/payment?client_secret=${paymentIntentClientSecret}&currency=${currency}&full_price=${fullPrice}&plan=${plan}&price_id=${stripeFirstPriceId}&next_price_id=${stripeNextPriceId}&subscription_id=${subscriptionId}`}
            />
          )
        }
      </Await>
    </Suspense>
  )
}
